// React imports
import React from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider, createTheme } from "@mui/material/styles";

// Css imports
import './index.css';

// Components imports
// import HomePage from './Pages/HomePage/HomePage'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './Pages/LoginPage/LoginPage';
import AuthProvider from './Components/Authorization/AuthProvider';
import AuthProtected from './Components/Authorization/AuthProtected';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#b8b8b8',
    },
    background: { default: "#121212" },
    text: {
      primary: "#000000",
      secondary: "#121212"
    }
  },
  typography: {
    fontFamily: 'quicksand, sans-serif',
    h6: {
      color: '#323232',
      fontSize: '1rem',
    },
    h5: {
      color: '#323232',
      fontWeight: '600',
      fontSize: '1.25rem',
    },
    h4: {
      color: '#323232',
      fontWeight: '500',
      fontSize: '1.75rem',
    },
    h3: {
      color: '#323232',
      fontWeight: '500',
      fontSize: '2.25rem',
    },
    body1: {
      color: '#323232',
      fontSize: '0.85rem',
      fontWeight: '500'
    },
    body2: {
      color: '#3e3e3eff',
      fontSize: '0.8rem',
      fontWeight: '400'
    },
    subtitle1: {
      color: '#3e3e3eff',
      fontSize: '1rem',
      fontWeight: '500'
    },
    subtitle2: {
      color: '#3e3e3eff',
      fontSize: '0.8rem',
      fontWeight: '500'
    },
  }
});

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <App/>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
